export default {
  'm': {
    'EnterID': 'Haz clic para introducir el ID de BuzzCast',
    'select-specifications': 'Haz clic para seleccionar la especificación de recarga',
    'check-account': 'Prueba la cuenta de recarga',
    'whatID': '¿Qué es el ID de BuzzCast?',
    'getID': 'Introduce el ID de BuzzCast',
    'maskgetID': 'Introduce el ID de BuzzCast',
    'toastTipsPlease-format-error': 'La forma de entrada es incorrecta',
    'toastTipsPlease-no-exist': 'El ID no existe',
    'toastTipsPlease': 'Comprueba primero la cuenta de recarga',
    'common-problem': 'Preguntas frecuentes',
    'transaction-succeeded': 'Transacción hecha',
    'transaction-failed': 'Transacción fallida',
    'transaction-cancel': 'Transacción cancelada',
    'whether-account': '1. ¿Cómo puedo verificar la transacción después de recargar?',
    'answer-whether-account': 'Después de la recarga, puedes volver a la APP [Mi]-[Billetera] para comprobar el Diamante',
    'no-account': '2.¿Qué pasa si no recibo el Diamante después de recargar?',
    'answer-no-account': 'Por favor, envía tu pregunta en la APP [Noticias]-[Noticias oficiales]-[Comentarios y ayuda], y proporciona las siguientes informaciones, nuestro servicio de atención al cliente te ayudará.',
    'recharge-money': '1. Importe de la recarga e ID de la cuenta',
    'recharge-time': '2. Tiempo y fecha de recarga',
    'recharge-shot': '3. Captura de pantalla del pago exitoso',
    'recharge-wrong': '3.¿Qué debo hacer si realizo una recarga incorrecta a una cuenta incorrecta?',
    'answer-recharge-wrong': 'Confirma cuidadosamente el ID de la cuenta de recarga y las informaciones del importe de la recarga antes de introducir la contraseña de pago. La recarga incorrecta no puede ser reembolsada. Si ocurre una recarga incorrecta, puedes ponerte en contacto con el usuario de la recarga real y negociar con la otra parte si está dispuesto a compensarte por la recarga.',
    'refund': '4.Reembolso',
    'answer-refund': '¡Lo siento! BuzzCast no admite actualmente ninguna forma de reembolso.',
    'buy-enter-link': 'La compra de Diamantes se realiza a través del enlace:<a class="web-link" href="https://pay.buzzcast.info">https://pay.buzzcast.info</a>, copia y abre el enlace en el navegador móvil para entrar en la página de compra, comprueba la cuenta y selecciona la especificación correspondiente, luego utiliza la forma de pago adecuada-¡Precio especial!',
    'buy-notice-a': 'Nota: <a>{msg}</a> es el único sitio web oficial de compra de Diamantes de BuzzCast',
    'replace': 'Reemplazar',
    'sureBtn': 'Ok',
    'pay-style': 'Elige el método de pago',
    'goBack': 'Volver a la página de inicio',
    'toastTips': 'Introduce el ID de BuzzCast',
    'rechargeFAQ_title': 'Preguntas frecuentes',
    'PayStatusSuccess_title': 'Transacción hecha',
    'PayStatusFail_title': 'Transacción fallida',
    'PayStatusCancel_title': 'Transacción cancelada',
    'Diamonds_title': 'Sitio web oficial de recarga de diamantes de {msg}',
    'buy-notice': 'Nota pay.buzzcast.info es el único sitio web oficial de compra de diamantes de BuzzCast. Para consultas sobre servicio al cliente, vaya a [Mensaje]-[Noticias oficiales]-[Comentarios y ayuda]',
    'RechargeHelp_title': 'Ayuda de recarga',
    'openAPP': 'Abra la aplicación BuzzCast',
    'buy-diamonds-tit': 'Comprar servicios de diamantes',
    'description': 'BuzzCast es el único sitio oficial de recarga de diamantes, BuzzCast es un software social internacional, con usuarios de más de 150 países y regiones de todo el mundo',
    'keywords': 'Recarga de BuzzCast, recarga de diamantes de BuzzCast, recarga oficial de BuzzCast, sitio web de recarga oficial de BuzzCast',
    'payforType': 'Método de recarga',
    'trueText': 'Ok',
    'falseText': 'Cancelar',

    'alertShowTxt1': '¿Seguro que utilizará',
    'alertShowTxt3': 'para recargar',
    'alertShowTxt5': 'diamantes?',

    'EnterIDTip': 'Recarga rápida {msg}',

    'scanLogin': 'Para la privacidad y la seguridad de su cuenta, por favor inicie sesión barriendo el Código',
    'scanTip': 'Consejo: haga clic en "Centro personal / dinámica" en la esquina superior derecha de "barrido",Escaneo de código de inicio de sesión, y soporte para identificar capturas de pantalla de código bidimensional de inicio de sesión',
    'scanVersion': 'Por favor, actualice BuzzCast a la versión %s después de iniciar sesión de barrido',
    'delAccount': 'Borrar cuenta',
    'logout': 'Cerrar sesión',

    'submit': 'Enviar',
    'email_place_holder': 'Ingrese su buzón',
    'contact_email': 'Correo electrónico de contacto',
    'provide_email': 'Por favor, proporcione su correo electrónico para recibir notificaciones de pago',
    'email_address': 'Dirección de correo electrónico',


    'sel_country_area': 'Seleccione país o región',
    'search_for': 'Buscar',
    'login': 'Iniciar sesión',
    'scan_login': 'Iniciar sesión con código de escaneo',
    'account_password_error': 'Error de número de teléfono o contraseña',
    'user_frozen': 'El usuario ha sido congelado.',
    'account_no_reg': 'Cuenta no registrada',
    'login_no': 'Usted no se ha identificado',
    'login_after_recharge': 'Puede recargar después de iniciar sesión',
    'scan_login_lesson': 'Tutorial de inicio de sesión de código de escaneo',
    'scan_login_desc': 'El método de inicio de sesión del código de escaneo puede realizar de forma rápida y segura el inicio de sesión del sitio web de recarga. Los dos métodos siguientes le presentarán cómo escanear el inicio de sesión del código.',
    'scan_login_a_title': 'Inicie sesión reconociendo capturas de pantalla de códigos QR',
    'scan_login_a_p1': '1. Es más adecuado para un escenario de uso de un solo dispositivo. El usuario ingresa a la página de inicio de sesión del sitio web de recarga, hace clic para seleccionar "Iniciar sesión con código de escaneo", se mostrará una captura de pantalla de la página con el código QR de inicio de sesión y el álbum será guardado. (La función de captura de pantalla es ligeramente diferente para diferentes dispositivos, puede buscar las instrucciones de operación de la función de captura de pantalla usted mismo)',
    'scan_login_a_p2': '2. Abra la aplicación BuzzCast, vaya al módulo de función "Centro personal" o "Dinámico" y haga clic en "Escanear" en la esquina superior derecha para ingresar al módulo de función de escaneo de código.',
    'scan_login_a_p3': '3. Haga clic en "Selección de álbum" y permita los permisos del álbum, seleccione la captura de pantalla de la página de inicio de sesión del código QR guardado, haga clic en el botón de confirmación "Iniciar sesión" después de que el sistema lo reconozca, vuelva al navegador y espere un momento, la página se cargará automáticamente al usuario información.',
    'scan_login_b_title': 'Inicie sesión escaneando el código QR',
    'scan_login_b_p1': '1. Es más adecuado para escenarios de uso de múltiples dispositivos. El usuario ingresa a la página de inicio de sesión del sitio web de recarga y hace clic para seleccionar "Iniciar sesión con código de escaneo"',
    'scan_login_b_p2': '2. Abra la aplicación BuzzCast en otro dispositivo, vaya al módulo de función "Centro personal" o "Dinámico" y haga clic en "Escanear" en la esquina superior derecha para ingresar al módulo de función de escaneo de código.',
    'scan_login_b_p3': '3. Alinee el cuadro del código de escaneo con el código QR en la página de inicio de sesión del código de escaneo, haga clic en el botón de confirmación de "inicio de sesión" después de que el sistema lo reconozca (se recomienda mantener una cierta distancia entre los dispositivos al escanear el código, lo cual es más fácil para que el sistema lo reconozca), y la página se cargará automáticamente después de un tiempo.',
    'scan_login_lesson_end': 'Lo anterior es una guía tutorial para escanear el código de inicio de sesión, espero poder ayudarlo. Para consultas de servicio al cliente, ingrese el mensaje de la aplicación-noticias oficiales-comentarios y ayuda.',
    'or': 'O',
    'input_phone_num': 'Por favor ingrese el número de teléfono',
    'input_email': 'Ingrese la dirección de correo electrónico',
    'input_password': 'Ingrese la contraseña',

    'log_in_using_Facebook': 'Inicie sección con Facebook',
    'log_in_using_Google': 'Inicie sección con Google',
    'account_or_pwd_error': 'Cuenta o contraseña incorrecta',

    'pay_fail_system_risk': 'Transacción fallida: sistema anormal',

    'friendly_tip': 'Consejos',
    'i_got_it': 'Entiendo',
    'android_fblogin_tip': 'Debido a que Facebook ya no admite el inicio de sesión de autenticación en el navegador integrado de Android, es posible que no pueda iniciar sesión cuando inicie sesión de esta manera. Si encuentra este tipo de problema de inicio de sesión, utilice el navegador Chrome para acceder a él.',
    'recharge_tip': 'El diamante finalmente recibido corresponde a la cantidad que ha recargado',

    'charge': 'Recargar',
    'link_add_mainpage': 'Añadir un enlace a la pantalla de inicio para la próxima recarga',
    'click_me_to_add': 'Haga clic para añadir',

    'user_has_delete': 'Este usuario ha sido desconectado',

    'support_contant_whatsapp': 'Si necesita ayuda, contacta con el servicio de atención al cliente por {msg} App：1924383',


    'buy_balance': 'Saldo disponible para la compra:',
    'official_coin_seller': 'Comerciante oficial de monedas',
    'paystyle_unavailabel_change_other': 'El sistema es anormal, este método de pago no está disponible por el momento, puede cambiar a otras formas de pago.',

    'failedPay':  'Problemas de pago, représtamo',
    "copied":  "Ha sido copiado",
    "reseller":  "Revendedores",
    "netword_busy_try":  "La red está ocupada, intente nuevamente",
    "placecommen": 'Introducir palabras de búsqueda',
    "app_all_v2": 'Todos',
		"use_phone_login": `Iniciar sesión con teléfono`,
    "use_email_login": `Iniciar sesión con correo`,
    "device_is_more": "El número de cuentas registradas para este dispositivo ha alcanzado el límite superior",
    "Operation_failed": "Este dispositivo se ha congelado permanentemente debido a infracciones de la cuenta",
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/es.js